// Shown when a listing has no photo: a plain house outline, the same in light and dark mode.
// (It used to be a broker's logo, which made listings without photos look like that broker's.)
const PLACEHOLDER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300">
<rect width="400" height="300" fill="#dfe7e4"/>
<path d="M170 152 L200 126 L230 152 V180 H170 Z" fill="none" stroke="#8a9b96" stroke-width="5" stroke-linejoin="round"/>
<rect x="193" y="160" width="14" height="20" fill="#8a9b96"/>
</svg>`;

export const LISTING_IMAGE_PLACEHOLDER = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(PLACEHOLDER_SVG)}`;

// The broker logo that older versions filled in for listings without one (cached listings and saved
// favourites can still carry it).
export const LEGACY_FALLBACK_LOGO = 'https://bcdn.se/images/cache/16732405_192x0.webp';

export const getBrokerLogo = (listing) => {
    const logo = String(listing?.brokerLogo || '').trim();
    return logo && logo !== LEGACY_FALLBACK_LOGO ? logo : '';
};

// First photo of a listing, never the legacy logo.
export const getListingImage = (listing) => {
    const candidates = [...(Array.isArray(listing?.images) ? listing.images : []), listing?.image];
    const found = candidates.find((url) => url && String(url).trim() !== LEGACY_FALLBACK_LOGO);
    return found || LISTING_IMAGE_PLACEHOLDER;
};
